import * as z from "zod/v4";

export const archiveSavedEmailSection = {
  name: "archiveSavedEmailSection" as const,
  input: z.object({ sectionId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
